import { render, staticRenderFns } from "./UnitOfMeasurement.vue?vue&type=template&id=6d256a6a&scoped=true&"
import script from "./UnitOfMeasurement.vue?vue&type=script&lang=js&"
export * from "./UnitOfMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d256a6a",
  null
  
)

/* custom blocks */
import block0 from "./UnitOfMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports